import React from 'react'
import PropTypes from 'prop-types'

const Checkbox = (props) => {
    const hasErrors = () => {
        return props.errors && props.errors[props.name]
    }

    const handleClick = (value) => {
	    if (props.handleClick) {
            props.handleClick(value)
        }
    }

    return (
        <div className={`checkbox ${props.value ? 'active' : ''} ${hasErrors() ? 'error' : ''} ${props.hasCross ? 'has-cross' : ''}`}>
            <div className='checkbox-container'>
                <div onClick={() => handleClick(!props.value)} />
                <p className='m-0 lh font-small'>{props.children}</p>
            </div>
        </div>
    )
}

Checkbox.propTypes = {
    value: PropTypes.bool.isRequired,
    name: PropTypes.string,
    handleClick: PropTypes.func,
    errors: PropTypes.object,
    hasCross: PropTypes.bool
}

Checkbox.defaultProps = {
    value: false
}

export default Checkbox



// WEBPACK FOOTER //
// ./resources/js/elements/Checkbox.js